const Settings =  {
    app_version: '1.4.8',
    push_time: '24.10.2026, 00:19'
}
export default Settings
